import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useSaves } from "@/context/SavesContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function HeartButton({ kind, id, size = 20, className = "", testidPrefix = "heart" }) {
    const { user } = useAuth();
    const saves = useSaves();
    const navigate = useNavigate();
    const saved = saves ? saves.isSaved(kind, id) : false;

    const onClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) {
            toast("Sign in to save", { action: { label: "Sign in", onClick: () => navigate("/auth") } });
            return;
        }
        const res = await saves.toggle(kind, id);
        if (res?.error) toast.error("Couldn't update saved");
        else if (res?.saved) toast.success("Saved");
        else if (res?.saved === false) toast("Removed from saved");
    };

    return (
        <button
            type="button"
            aria-label={saved ? "Remove from saved" : "Save for later"}
            aria-pressed={saved}
            data-testid={`${testidPrefix}-${kind}-${id}`}
            data-saved={saved ? "true" : "false"}
            onClick={onClick}
            className={`inline-flex items-center justify-center rounded-full transition-transform hover:scale-110 ${className}`}
        >
            <Heart
                size={size}
                className={saved ? "fill-accent text-accent" : "text-current"}
                strokeWidth={2}
            />
        </button>
    );
}
